class LeftPanelDropdownFilters {
  selectIcheckboxphone_numberLeftPanel(user_input) {
    console.log("This is selected:: new LeftPanelDropdownFilters().selectIcheckboxphone_numberLeftPanel");
    console.log("This is selected:: ", user_input);
    console.log("This is selected:: new LeftPanelDropdownFilters().selectIcheckboxphone_numberLeftPanel");
    var val_checkbox_phone_number = document.getElementById("checkbox_phone_number_left_panel").checked;
    token_obj = {
      token_obj: "checkbox_phone_number",
      value: val_checkbox_phone_number,
    };
    updateStorageToken(token_obj, "checkbox_phone_number");
    new Query().fetchQueryShowResults("load_data_without_loading_tokens");
  }

  selectIcheckboxemail_addressLeftPanel(user_input) {
    console.log("This is selected:: new LeftPanelDropdownFilters().selectIcheckboxemail_addressLeftPanel");
    var val_checkbox_email_address = document.getElementById("checkbox_email_address_left_panel").checked;
    token_obj = {
      token_obj: "checkbox_email_address",
      value: val_checkbox_email_address,
    };
    updateStorageToken(token_obj, "checkbox_email_address");
    new Query().fetchQueryShowResults("load_data_without_loading_tokens");
    // console.log("This is selected:: ", user_input)
  }

  removeLeftPandelforOrgChartwhenLoggedIn() {
    console.log("Removed left panel when logged in");
    try {
      document.getElementById("left_panel_org_chart_people_companies").innerHTML = "";
      document.getElementById("left_panel_org_chart_people_companies").style = "";
    } catch (error) {
      console.log("Error:", error);
    }
  }

  removeLeftPanelforOrgChartwhenLoggedOut() {
    console.log("Removed left panel when logged out");
    if (sessionStorage["logon"] == "false") {
      document.getElementById("left_panel_org_chart_people_companies").innerHTML = "";
      document.getElementById("left_panel_org_chart_people_companies").style = "";
    }
  }

  removeInputsinLeftPanel() {
    document.getElementById("prospecting-style-tag-filters-container-create_new_job").innerHTML = "";
    document.getElementById("prospecting-style-tag-filters-container-view_all_jobs").innerHTML = "";
    document.getElementById("prospecting-style-tag-filters-container-upload_new_jd").innerHTML = "";
    document.getElementById("label-select-create_new_job").children[0].children[0].setAttribute("data-original-title", "");
    document.getElementById("label-select-view_all_jobs").children[0].children[0].setAttribute("data-original-title", "");
    document.getElementById("label-select-upload_new_jd").children[0].children[0].setAttribute("data-original-title", "");
    // document.getElementById("action_buttons_left_panel").innerHTML = ''
  }

  getTooltipTexts() {
    var tooltip_texts = {
      company_name: "Sensitive to spaces and first set of letters in the company name",
      gpt3_company_search: "Provide a rough description of the companies that you want to fetch. Eg. 'Give me the largest companies that manufacture chemicals in California'",
      reverse_company: "Populates companies that a company hires most frequently from",
      reverse_job_title: "Provides candidates similar to the title you provide",
      company_id: "Linkedin ID of the company to search",
      description: "Alberta Carlo",
      industry: "Alberta Carlo",
      tags: "Alberta Carlo",
      employee_count: "Alberta Carlo",
      company_type: "Alberta Carlo",
      company_sizes: "Alberta Carlo",
      person_linkedin_url: "Alberta Carlo",
      company_linkedin_url: "Alberta Carlo",
      founded: "Alberta Carlo",
      region: "Alberta Carlo",
      locations: "Alberta Carlo",
      functions: "Alberta Carlo",
      function_root: "Alberta Carlo",
      search_in_org_chart: "Alberta Carlo",
      grades: "Alberta Carlo",
      job_title: "Alberta Carlo",
      reverse_job_title: "Place a simple job title and the bot will fetch all similar job titles",
      website: "Alberta Carlo",
      person_name: "Alberta Carlo",
      genders: "Alberta Carlo",
      country: "Alberta Carlo",
      revenue: "Alberta Carlo",
      locality: "Alberta Carlo",
      inferred_salary: "Alberta Carlo",
      education_degrees: "Alberta Carlo",
      education_majors: "Alberta Carlo",
      school: "Alberta Carlo",
      naics: "Alberta Carlo",
      email_address: "Alberta Carlo",
      phone_number: "Alberta Carlo",
      skills: "Alberta Carlo",
    };
    return tooltip_texts;
  }

  getIcons() {
    var icons = {
      company_name:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAhElEQVQ4jWNgoBAwMjAwMKiUnGljYGAoZmBgYMOh7hcjA2P37R7jGnQJFihdzP73l+TVfqt32HRrFx4T+snM9oyBgQHDAAaoC/6j09jEcPoDryQBNUy4XILNZpg4FF+lyAUwPkkuwGnZCHcBigF3ekwY0W1GF0Pnw/ICQS9gA9gspD8AAAtDdyS/pu7BAAAAAElFTkSuQmCC">',
      reverse_company:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAhElEQVQ4jWNgoBAwMjAwMKiUnGljYGAoZmBgYMOh7hcjA2P37R7jGnQJFihdzP73l+TVfqt32HRrFx4T+snM9oyBgQHDAAaoC/6j09jEcPoDryQBNUy4XILNZpg4FF+lyAUwPkkuwGnZCHcBigF3ekwY0W1GF0Pnw/ICQS9gA9gspD8AAAtDdyS/pu7BAAAAAElFTkSuQmCC">',
      company_id:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAhElEQVQ4jWNgoBAwMjAwMKiUnGljYGAoZmBgYMOh7hcjA2P37R7jGnQJFihdzP73l+TVfqt32HRrFx4T+snM9oyBgQHDAAaoC/6j09jEcPoDryQBNUy4XILNZpg4FF+lyAUwPkkuwGnZCHcBigF3ekwY0W1GF0Pnw/ICQS9gA9gspD8AAAtDdyS/pu7BAAAAAElFTkSuQmCC">',
      description:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAt0lEQVQ4jWNgGGjAiMxRKTnTxsDAUMzAwMCGpu4rA8N/nzs9pgcIGfCT/e8vyav9Vu/QxP8zMDC8YmD4H45uCBOagWzommHg33+GYAYGxpXKJWedkMVZsCnGBpgYGQ5DnPx/EwMDAw9WRVCn4gXoatC9QDLA6QV0m+70mDBiU4fTAFwayHIBPsModgF6IP7SLjwmhEsxVO4nThcwMjB2/2Rme65ScgY9KTMwQHT++s/I0EWMy+gHAGe1Ow+sfBu8AAAAAElFTkSuQmCC">',
      industry:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAABY0lEQVQ4jcWPvy8DARTHP+8cIbRW3UqOSJAQp5PZYBDsEpPJ5FxiNxiU7rr5J1hELIbeNYTaLu3MIkLiR12fAZdDTxjEd3vvfb+ffB/8tyQ+WI5fQRj6NqFcBFv28Ptoxm/PqVvbvEtdB3m7o1nWWvUfeOoej++MD3WuO7oRbqKA609Zjl+JWW7ouk0nAsw2IyPKJUC/U54HdlUbSzHLVVjXTCJAGzKiUAFQ0Q2Ug/Z0px81RCotykjyC8iEIKcAtBqToKnHu/vjAccffDU0TlQ0l9xAmA5D3QcwVTqD/MSMCl4IewDPauwLTDcFWCveGIJUC/Y5QL0eHlqOtyDKvBiNRYBafvxMFbPfLY1+bSDGMlCMRiGLyC6IE2zmjmL7HVVj+QMg65Z6EJ01zTACRG+prg+unWSjgFIE5rJuqScyWatewXLL25/DSbLc8va7X14BfhXo/SngTbUgb/f9MvMHegFtRnvRpbJ7EAAAAABJRU5ErkJggg==">',
      tags: '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAB9klEQVQ4jc2Sv2sTcRjGn/fyTa5J7y5dHKw3FBIRzCCYgNCpf4Cbv4jtIBYFhQ6FKAgiwaVDAx3EFgR1kYQigSLimkWKw1VxCIp3sQRScLBCkqvNj7t7HWzayxknF9/x/T6fh/f58gD/ODRqmb5phJsaPQU4C0AcrHsEWjYL6ft+rTQKbmlYB7HacXuaVciQVciQ7PaOMzgX1A8ZzOQroqlRiYlC8nj0SmNleh9gSuSM19WV6R8A5GTO6CRyxsMBI/xww1aLgBeRx2MXq/lU7yAl1wo4fwiE3RNOP7QD4MHhBTP5imi0lRcMxNCduHQEH81k3ogB6H9eOrcLQB6KsLOnPAZJGnXjF6xHJ7tBOLlgyrE9KhFQDL4JAGCmLHtuqjYCnspXxshulpnxU2vhhr64GQXgBD9xlSRaTy680/ywvrgZFba6AVBLV9rZzmSUxkSkCFBpyMAqpO8B9AGyeHPq7lt1kFkOya9A+G7Wa3ONXT3Ube+XmdmLt3h+YOArElPiztYqMZ8RQlx1HPc5AXWz/nV+KnUsHLbVMgN2vIW5rSeZfjACAOLacvo2E310HHebiL+YSvq6rusRYasbHqGpK+1ZPxy4wHdJ7v0awKfhebOQQs8I3jervn0NLy+7QfUfVf5dnLO3iMggSapKzJ/+Bv8f8wuB0sdVuk6iFAAAAABJRU5ErkJggg==">',
      employee_count:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAABRElEQVQ4jeWQTStEcRTGf+d/LzLs7MnLLGShmW64VooUC/EVsJBig2wUK6FZWLAz30FSNvbTvLBQSk1JthakDDL3fyzc4U6GvTy78/L8es6BPy+JFh2rhVZjOUDxETLWMHu97d3+BnCraIGkQU9j1E2V9G3RWA6A0fal8zbXBGlVGVAko47OVMCmOo76DaXG/YtU75NjXvZQBgFC8zDQJOhICOYbAMi/xp4XeuYvm4OgcQHIAqiKX7UVgr+d4BidC6zkXmPPm8CjFccLRzlgKALIfaUO1bmUH0MkLcoZRopYjSMkUZk21hatIzmgBbhzXafvaitx8wnoWikkUU4EJoopL1uBxpcL/QqHwD3QHbkhUy674ze7iYePH6huKLIWNQMUU15WVdarzQDiu26wE3miDNSX9ZgaCkxwVKsPTP7Q/3d6ByfieRWoN8XZAAAAAElFTkSuQmCC">',
      company_type:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAABbklEQVQ4jb2RvUtbYRjFf8+bSw1qQcTRpeVGO2vFj9GugoP+ByotiEPxWqTSFsGP0kbonr9AXIUuxtXUXBdJKa1aF9fQzTSS3NMlptqoVxF6xuc87znnOS/cEwbgB2ERaL+CLx6mn3bEqvhBqLvML8LFqsfAa3B9leuUvAUTw7UU34EsrrJy+GHgJDaB5C04WZvQ2GkrLUJjMtqIvNe3SmDiWQXGj9N9hdqo8PhluEqCjZsEihcLe4h3VD8pyI8Cb4BuPwhzZrZ08LF3s27Y0EEQ/qhi48fp3n0/yI9K9klyk60ukfvN2WBVlnHOZs5FGk6QkXVo/lGw9x70FrOJn2s92zV6qyvIT0XSKrAJV5RoVlk28SuB1oGe5Gly9xLvyl/Auv/toI7aV00D+HPhTilZ7gey53xUbRoAvl0rcMkNW3YuyqRm888flJp3yi2lIYmMpBd/d2KQmtsbkaJ3YE+Ar5IWj9b6Pse9+3/4A+BKiR3h89E8AAAAAElFTkSuQmCC">',
      company_sizes:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAkklEQVQ4jc2SsQ2DQAxFnxGToGzAlTRMETEHGeMWScEKEQPcCLBAlnCKIARIHD5ocGn7veLbcLHEsvR4Bd32Bu8EILMIBu/kD2gNfJczkwCgaEMF8lakSRYUbagyoVOkGX35SRLEYDgI8QiOCizwrsAKw5TB8s4p8Cw4C68EZ2CAfDYJHehz9K63wjCFGPv1+9cPLIVH4sYdNnUAAAAASUVORK5CYII=">',
      person_linkedin_url:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAA+0lEQVQ4ja2QsU4CQRCGv7lcLCzkIVgL0UovhMb4CL6ChfEFbhNbakEtbXgbwxVmj9YCMFbGEhKtDDsWSDzEcw/1azazM/+ffwb+iADU0/xMRDvAVgXNFMWOLpMeQAwgoh2JpDW8OLgPqU06aCA+A3qfn9bp/M3729bdBk0+5gGi5X3Ue9BVSTlxsRh2k8N1xCsGi2ijbiKFmDfACfCo3p+Or5pZUbO0QgnHwDOwIxJd/5jgO3QmRxuqr28xTwh7axuMa/sPAOYlB9j82g+v0BZPW3xZu8oNwhjrJiYdNCrNnt/tGusmi3p+A8UiPjPW1YIOM6ag6W/D/j/v21BNKYrFtmgAAAAASUVORK5CYII=">',
      company_linkedin_url:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAA+0lEQVQ4ja2QsU4CQRCGv7lcLCzkIVgL0UovhMb4CL6ChfEFbhNbakEtbXgbwxVmj9YCMFbGEhKtDDsWSDzEcw/1azazM/+ffwb+iADU0/xMRDvAVgXNFMWOLpMeQAwgoh2JpDW8OLgPqU06aCA+A3qfn9bp/M3729bdBk0+5gGi5X3Ue9BVSTlxsRh2k8N1xCsGi2ijbiKFmDfACfCo3p+Or5pZUbO0QgnHwDOwIxJd/5jgO3QmRxuqr28xTwh7axuMa/sPAOYlB9j82g+v0BZPW3xZu8oNwhjrJiYdNCrNnt/tGusmi3p+A8UiPjPW1YIOM6ag6W/D/j/v21BNKYrFtmgAAAAASUVORK5CYII=">',
      founded:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAA+klEQVQ4jb2SMU4DMRRE3/euNn2oaJFTpYoCN6DnJohoTReJBqVgt+EmHIA6DQYOEKCEio4Cr4hNsysF5ARHIF7lP2P9GcmGv0QbG7b1pTVmQAkUCTmNINWiHk8B8lYse8tm12XF60O9L5satPeegWly9dii7pzHxK35TQMVM7SxM23s28DcnsfmVdR3oaX0ko0CwQAE+PBeHQXC8cYFKy9QPFWjBdADeKzHZ0r5a+AmtUGzd3o/AByALu2J9+oQOEhaIEilwvIuCBWAiNpRyl8F4TIap411w8m8v6bNF4aTeV8b+97NeZfosuJFG/vjV3bQBOEiJex/+ATR/GUPKHJqNQAAAABJRU5ErkJggg==">',
      region:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABnUlEQVQokW2RMWhTcRDGv7v//5XWFooIIqIWmqSCi0LyOsRNXQQ7OItdHDoUl9hExEXFoeqLIk66RQVRR4fiLKg0SQvFLS+hi0IpHUpbSMnLfQ5qjMGb7uN+B/fdJxioqVJ12kwvgqTBllrl6Wr/XPtFuvT1mJmc914rPnAvVfTCydLK0X5G/jSTN2snNOFDqNwmOSfEAag8AbHo0C3tjLmNH8i2ewuphfplhR0msUWBV4hCuG+m6yI2A2KbIgf1F1y7J8IjQ93Oe6jmm1HubSPKviEl3yxn63EU3qHpBwHNZ4r1S2b2JY7CJQCYKqxU0jfq1yAkDK97tzubT8Z2bymMZ0z0OwCkCsvHDd0JAbxQgvhxuNpzS9209qER3yjn7qeLtbsA1qAyTpGJ+FHu2eC7aXgXJPtX/G/RShWW880o/Azg2yAMAHCcHcXQAwWAZjlXUdFz/wUBTBZXMyrSWotO7/m/iXAzs1CdI90nQzKq4maF3DAJXjDpDEMx/E/SjSh87rz/CHRPqbizcZS9rq79FOxcVZWZEQleAcBP7BalkKBy3KwAAAAASUVORK5CYII=">',
      locations:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABQklEQVQokXWRTyvEYRDHP/P8nr2xeQFks7+DkiTW1corkFIuDnLSHqTdsid7kDYUiZSSuwP7DpATNpIcFknZExehxD77Gwdtdi1zmvn+mWlmhF8Rz+zbh9dwF0BL48vFQWbAVfNSXfjJ0zgwL8IlgCqdiKZvF/sO6wx+Kh9F2XTOG75f6X4GiEydN1mvvGsCnbhejt0B2IpBVVJGg2zIBhvt6eMEgPt06xjJBiJJYLLGIAStKpQELbqStwqAoQjBB3iRiu5nAlwaMQ0ozTbkEgDlkl1TvLDq9041BmvYKqtmb5d6h6ruMOqn8nvW6EwFMJWksBAroDy1TZ8N/hzipF/Qx8JCrFA3ASDkmHU22OnIXB0BfL69z1nHSLWm5g/fXU/HCYgiIoLc3Cz1bP/W1IWfzOf8ZD73F2f/AvlwY/81+wIxcHKGN+s7SQAAAABJRU5ErkJggg==">',
      functions:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAAkElEQVQ4jWNgoBAwYhNUKTlzhIGBwRpJ0ZHbPSa2RJuqUnLmPz4+MmAi2lRaGcCCTZCRgeEIsrP/MzAcJst0fH5HsgxFQxsDA0MxAwMDGxa1vxgZGLtv9xjXIAuie6GY/e8vyav9Vu/QdWsXHhP6ycz2jIGBAcUARqjNeOOdYLogFO/4+IMkHRCKd6qlC5oAAAs3PXl0aI69AAAAAElFTkSuQmCC">',
      function_root:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAA2klEQVQokbWPMUoDURCGv3m7uIGA4gHShHcCMSBYCXam9QTWCRiWpN1ahEhS29p6gRQWWwire4JgkxuEgBDcNxZhzS68EFL4w8DMfMz8M3CgpFYlauwqvwEdAQ0VnbSaq5e35OqnNmB778ccBXeK9BEWIOMN1nuUlqAT1sXzfHqxDAGIggHItRpz+/Vw9lHxfG0P83Nx7okoOAGScMt0ZlzRtXHWrZ3pCoBZWYZVNn/sJL5HbZz99cNdYJf+38GUiWIuQb59sWEVBwOpQxvAqW+roJ8G0n3uXv0Cr31F9tNZ0OcAAAAASUVORK5CYII=">',
      search_in_org_chart:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAA2klEQVQokbWPMUoDURCGv3m7uIGA4gHShHcCMSBYCXam9QTWCRiWpN1ahEhS29p6gRQWWwire4JgkxuEgBDcNxZhzS68EFL4w8DMfMz8M3CgpFYlauwqvwEdAQ0VnbSaq5e35OqnNmB778ccBXeK9BEWIOMN1nuUlqAT1sXzfHqxDAGIggHItRpz+/Vw9lHxfG0P83Nx7okoOAGScMt0ZlzRtXHWrZ3pCoBZWYZVNn/sJL5HbZz99cNdYJf+38GUiWIuQb59sWEVBwOpQxvAqW+roJ8G0n3uXv0Cr31F9tNZ0OcAAAAASUVORK5CYII=">',
      grades:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAA9ElEQVQ4jaWSsU0DQRBF319SKAFjhANiZGSOiAhacISL4E6iBxtRAy6BDCJEckKcoAAuceoCIADvJzABwa2lsyeaGT09/ZEGNiw1LXt5NQM6/1azetLvNrGhWRsvgblFAcxRHLVKANArqnPMA+KiHvcfU1xzAiCgL4AY+UwxKwULPACiAidrCYI5RdxjZ2sJDAPFcAtqLzi8fu8CfNwcPQvi/tXbXivB4vsnA5XLJH4JWiRTJE5QZrtctipXndEosJzhWP5NZWgrQNqVtnYAFMO25U4jlxTYQ+TpQVHlyFPsYUqQfuX89Qx0Bx7Vk+OnFLdx/QKajk0d6cHnpAAAAABJRU5ErkJggg==">',
      job_title:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAAqUlEQVQokWNgIBEwoguolx3h/fuPYw0DAwMD+zfO4KvTtL+gaFDMPyHOzMpylYGBQZiA4W//M7BqMTGxsMoQoZiBgYFBmOH/H1kmYt0OA7g0PIZiTA0sjH/eMTAw/Mcihx4g/1lZmd6yfOZhfsnxkUGfkYmRDZ9T/v/7/+sTz99XLJyfGTUZmf+fwW4JknXMDAycnxlNmBgYWR4zMDC8xasaAt5A1dIYAAAb+yhvnfihFAAAAABJRU5ErkJggg==">',
      reverse_job_title:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAAqUlEQVQokWNgIBEwoguolx3h/fuPYw0DAwMD+zfO4KvTtL+gaFDMPyHOzMpylYGBQZiA4W//M7BqMTGxsMoQoZiBgYFBmOH/H1kmYt0OA7g0PIZiTA0sjH/eMTAw/Mcihx4g/1lZmd6yfOZhfsnxkUGfkYmRDZ9T/v/7/+sTz99XLJyfGTUZmf+fwW4JknXMDAycnxlNmBgYWR4zMDC8xasaAt5A1dIYAAAb+yhvnfihFAAAAABJRU5ErkJggg==">',
      website:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAABmElEQVQ4ja2SwUtUcRDHP9+faxFYgjcjNfSdkiDcJ5GnvIrRwbA/oUMYLD7z6jVsl0XokKB/QHnonAfbPSwlby0PXuK17KbYJTxoRJD+poPZ1rqHqP1eZubDzDAzDPyn1AiCmXjIIJKRBnqAbSBGZJP5cKMx39VdUzBTzmGsyBgHvXRGL2arwC2MlSCKs2Bq2mAgKucxuyLpgcHupY79zPts+LnzQBngk2AKcTWI4typBv3T68MS42e/nrtjZmNOtvxqbvQQoLwYfgeWDcba9G0CdLt/en3436/WIAVRXHXOJr3XG+fsuvd6BvA3LHkcXm7rGrk35D1piV7vdUHSNqh2mlH1XmGd8XGvtPjCgS9I3AWeHltfaM6s+CezIoDzShWBM4fyC0C7V6rYjNmRK/zOfsYtOOKJc/wkXEM8MmPhQ60yyPPJo5tza6mdL+e3EFMYs4i3yXwYndT9eqSkVnmItImxJLgY9A3kBzOlrp2DjjzQjbEEvEuqldmmE9Qn2biB/H2MEaAbsYtZCe+eJLn065bs3VL9AFt5vWTxQ/zNAAAAAElFTkSuQmCC">',
      person_name:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABG0lEQVQokXWPsUrDYBDH/3dG6VJEOikUC2kwLro4OIk+gdCh4BNUnIwGaTd3BX2GLg7iGwiKk8Wm3dpFEZ/AoWCtyXfnoK1JE7/pvvvxu/8dkPHcRqvgNlqFLEbjwvaCMltSUSUCsPfbviJSVdDN89nGCwDwxGS9ALjH0EAJPSX81Mp9CC5TUWW/fTdZqd4tufVuKYtxWnzaDiPTDCPTdI47W9PcSh9Fa0q4ZgUJyzqAhzhPJSiRgeBIFB4JzDRPCCsnnSVAd4v5gVPMDxxirawethf/XWn0RR8zRAf3pzsRANhesD8ED61YUEKYY102jHPbD/56or5kJRDwJmSqBLqNDxGSKoDXlKCj+Rpy75usmE0IrCE+Fx7H/28b7md+SPbY+wAAAABJRU5ErkJggg==">',
      genders:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABQElEQVQokbWRsUvUYQCGn/e7+4ng4GKDoCB3p9AUWOQ5CDqIQw0S2ObiEAQO4c8aamkT5FDBQUEQZwUH/QcaK08CFxvOGzQRsRCFw9LzextaFBztWZ+XZ3nhf6OHb8qtV1lKQA9ml4YwVpnqPsmn26+CPGoUIE5XSk82QFYhLW8int+I1GQmLRZup6mGugcDoh84A75gfQAukdpuTM+AQ0wuZpRmBVX/qfdV5ovnAIXJraLNJeJUMHuluJTEMGyxgOgMUWw4Cc0AhXef2wzvHUgQyzHGlY6m2k/LRwCyfgXs3xmFC4DKdPEH1pAgYh7szTw9+PRxoG5CAIjycUiSuBjlcYDc22+dkq4xz4AX+Ymv7YysZsQ/r0ivAPLp9mPJIzYne/vVOdZeXnel5RaL17YbTVhvUvb7TulR7Z5vvYO/YyZ92pzAOzQAAAAASUVORK5CYII=">',
      country:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABf0lEQVQokX2RPWuTARhFz33SDEIp+AeKlDRVEYo10Klq3RQcKv4DPxY30+AitaCbpE7ikMnJQRDUwc0UV9/q4FASGzHiIgha6WLJ+1ynlgriHS/nLPeK/2R6uZhPseCyfPFpbb4PoIPAqetFdXvCF4CTdhxC/i2cRocr5m6/3fgee3D95rvZ7QmtYV3FDEI+EShEDGXvjByzAAEwdauYzEq2nOUTxAdH7Br3EVul8ptFVfZwX4jkCvAcxTWbntIzWD9Iz1Wdm3L81Jgv7wtYuXW/8TRgMGg3HkeoG6FuqHxQUnnE7kRbOAF0drU79nVn/CVoHVgEuhZHAGQ+A+eA16AzW8PBRQBqyxt3AKabxW2Aemtjod7aWDjY1ZrFyv6stWaxQrCJfV6KN05PAij0xc7TSK+UzHxsN+4FQLWkI+sSVDqZHHOo51Avnceh0jEsjUajzl/H1ZvF0ZRuQNZMPMNIyiWjvrN8+M+nWXVM/Xq/GJENAKO3g/G5dVaVe8gfaxWwyikbPHMAAAAASUVORK5CYII=">',
      revenue:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABWElEQVQokYWRsWpUYRSEv/nvzbqJEQMWwZgmZkUICrpaanobrUSfwNbC3QewUvIUIoKNpb2WSi6GFCJBDBpICheFuGQ30fufsYiKCBenOQycjznDgf/o0p1q4m+vpsXOvTdLIpYttYUjpfRsY6W7k5oAEctObGLP1uhl5LgO0AgY75E9IPG9KHIOONrprd4oO/1q0eiycPyTcRH8Fpj75YcyJ5PQVUsfsrWR5E8yW4TniVgDX7D9UVlX2sfajwx1CbC50q3+lO1XN5konjjHOdd5e3J/eudganTrYDi+n6WnJcDp/tqZwvnaj7p4LOp4/6A7AF4s9lZv70+PT6VIEfi167SVACbr8ZcwuydGeY+gBbBw99WspK9SfEYMfl9QAoxTa6ks/G73uM6LNOz0qoeYEfCcSEcIfQMvHAIR2xLzYWWFSzCCdQCCs4cj5pKYas+0Rk1vaNRP9ViXFQRwIGgAAAAASUVORK5CYII=">',
      locality:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABf0lEQVQokX2RPWuTARhFz33SDEIp+AeKlDRVEYo10Klq3RQcKv4DPxY30+AitaCbpE7ikMnJQRDUwc0UV9/q4FASGzHiIgha6WLJ+1ynlgriHS/nLPeK/2R6uZhPseCyfPFpbb4PoIPAqetFdXvCF4CTdhxC/i2cRocr5m6/3fgee3D95rvZ7QmtYV3FDEI+EShEDGXvjByzAAEwdauYzEq2nOUTxAdH7Br3EVul8ptFVfZwX4jkCvAcxTWbntIzWD9Iz1Wdm3L81Jgv7wtYuXW/8TRgMGg3HkeoG6FuqHxQUnnE7kRbOAF0drU79nVn/CVoHVgEuhZHAGQ+A+eA16AzW8PBRQBqyxt3AKabxW2Aemtjod7aWDjY1ZrFyv6stWaxQrCJfV6KN05PAij0xc7TSK+UzHxsN+4FQLWkI+sSVDqZHHOo51Avnceh0jEsjUajzl/H1ZvF0ZRuQNZMPMNIyiWjvrN8+M+nWXVM/Xq/GJENAKO3g/G5dVaVe8gfaxWwyikbPHMAAAAASUVORK5CYII=">',
      // 'countries' :'<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABf0lEQVQokX2RPWuTARhFz33SDEIp+AeKlDRVEYo10Klq3RQcKv4DPxY30+AitaCbpE7ikMnJQRDUwc0UV9/q4FASGzHiIgha6WLJ+1ynlgriHS/nLPeK/2R6uZhPseCyfPFpbb4PoIPAqetFdXvCF4CTdhxC/i2cRocr5m6/3fgee3D95rvZ7QmtYV3FDEI+EShEDGXvjByzAAEwdauYzEq2nOUTxAdH7Br3EVul8ptFVfZwX4jkCvAcxTWbntIzWD9Iz1Wdm3L81Jgv7wtYuXW/8TRgMGg3HkeoG6FuqHxQUnnE7kRbOAF0drU79nVn/CVoHVgEuhZHAGQ+A+eA16AzW8PBRQBqyxt3AKabxW2Aemtjod7aWDjY1ZrFyv6stWaxQrCJfV6KN05PAij0xc7TSK+UzHxsN+4FQLWkI+sSVDqZHHOo51Avnceh0jEsjUajzl/H1ZvF0ZRuQNZMPMNIyiWjvrN8+M+nWXVM/Xq/GJENAKO3g/G5dVaVe8gfaxWwyikbPHMAAAAASUVORK5CYII=">',
      // 'country' :'<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABnUlEQVQokW2RMWhTcRDGv7v//5XWFooIIqIWmqSCi0LyOsRNXQQ7OItdHDoUl9hExEXFoeqLIk66RQVRR4fiLKg0SQvFLS+hi0IpHUpbSMnLfQ5qjMGb7uN+B/fdJxioqVJ12kwvgqTBllrl6Wr/XPtFuvT1mJmc914rPnAvVfTCydLK0X5G/jSTN2snNOFDqNwmOSfEAag8AbHo0C3tjLmNH8i2ewuphfplhR0msUWBV4hCuG+m6yI2A2KbIgf1F1y7J8IjQ93Oe6jmm1HubSPKviEl3yxn63EU3qHpBwHNZ4r1S2b2JY7CJQCYKqxU0jfq1yAkDK97tzubT8Z2bymMZ0z0OwCkCsvHDd0JAbxQgvhxuNpzS9209qER3yjn7qeLtbsA1qAyTpGJ+FHu2eC7aXgXJPtX/G/RShWW880o/Azg2yAMAHCcHcXQAwWAZjlXUdFz/wUBTBZXMyrSWotO7/m/iXAzs1CdI90nQzKq4maF3DAJXjDpDEMx/E/SjSh87rz/CHRPqbizcZS9rq79FOxcVZWZEQleAcBP7BalkKBy3KwAAAAASUVORK5CYII=">',
      inferred_salary:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABWElEQVQokYWRsWpUYRSEv/nvzbqJEQMWwZgmZkUICrpaanobrUSfwNbC3QewUvIUIoKNpb2WSi6GFCJBDBpICheFuGQ30fufsYiKCBenOQycjznDgf/o0p1q4m+vpsXOvTdLIpYttYUjpfRsY6W7k5oAEctObGLP1uhl5LgO0AgY75E9IPG9KHIOONrprd4oO/1q0eiycPyTcRH8Fpj75YcyJ5PQVUsfsrWR5E8yW4TniVgDX7D9UVlX2sfajwx1CbC50q3+lO1XN5konjjHOdd5e3J/eudganTrYDi+n6WnJcDp/tqZwvnaj7p4LOp4/6A7AF4s9lZv70+PT6VIEfi167SVACbr8ZcwuydGeY+gBbBw99WspK9SfEYMfl9QAoxTa6ks/G73uM6LNOz0qoeYEfCcSEcIfQMvHAIR2xLzYWWFSzCCdQCCs4cj5pKYas+0Rk1vaNRP9ViXFQRwIGgAAAAASUVORK5CYII=">',
      education_degrees:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABLklEQVQokZWRrU9CcRSGn/PbTSIUq5c5wEJiE+UaDCZn13/hFpo4qWQHUkhUmwaicwZtgmKk4HVzQ6IFcDPcyzGAV/ya823n7H3OznkP/FMyWySK7bj4khcZOwCqpokGtYejtd43IFm43RaRE2D+y9AhKrteZeU8BBLFdtwEdH4wf0DGT3uHzpMBEF/yQESgoYiL8W2MbyviCjSAOQIrD2ABiJADhmORehAZXD2WNl8BlkqXx7zEeqK6geCEwFQxUT2zRtHW8n77GUBHLIDmZnczkzRovTe8ctaRwHIlsFyvnHVCp9IMj07u3dhiTAeIAj1R6gAquIANDExgpbvVTD+MNVW420L0dArNaiCqO/eV1YtPfwBIHTQXCaw8IuuTNfTajK1at5rp/xL333oDAExl+ygWtWIAAAAASUVORK5CYII=">',
      education_majors:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAAAiUlEQVQokbWQsQ3CQBRDn78yBlDBBtCnp2cEJsgY0MMCrEAd0WYEWOVMBZxO0REKXP5n61uGf0sAy27wFPP9sBZTAy9P/FqpKQ+rbtgazoBt7x/HzbUaMJyc0s6KCOkCLHI+VmlmRTQhAfOvlQBC3JLHd3h/qC2VM9UgZNuXHz5Sj1KLUgvqS/oE9u0rYFIp6I8AAAAASUVORK5CYII=">',
      school:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABK0lEQVQokZWPv0tCARSFv/uKMrE2l6Sg5xMitEmHoPFBi0FDOhkN/QXSW5yqXafWFqFBoi0XpdHtPR0aIkhs6F8QScF3G/yRVBJ904V77rnnwD+R6ZS5WzA3zT1DSCscCQREtKZqVOmv1dvXsT6ArF96wWCXMmCDPINWFX0YuckhSBp0B3jshTgFwHKaWavQCs+LYRVaYctpZgEMANSPyGBom3kv8V1s5r2EDIY26kemHSzHU9BbRVICoujFONKVggrqguTaxaQsTpzaxdQJgHnu7YvIDYCvnHVKycbYNPcVaYZOKdkQtCJoZSKe5cfBX8x04A14QqiBxEZrfUU5AHaBrWmH5d7K6iD0seH7bINmRPUYQIV7kLJh8LLUDbzPfRt13HjUceO/7T4BojFmrCqiUGsAAAAASUVORK5CYII=">',
      naics:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAACNElEQVQ4jZWST0hUURjFz7nv+mYU/0xUEAgJztMMIRgdAltELYKgrUGkEBW4a2HN1NZVZTi0aBVF0KIW0r9dEEKLjCJnaJMEzSg0/ZMkJse0GX33fi2cqTcWVmfz3ftxz+H33XuJDeSdet7McN3eslP3NH9xV6E9+bJDlRrzuSsd5eoZHTTsODvZ5NtwkkAUkM8E20Rwr6norEaTmYMUczK0eWUg6FHBjSC0k8SD3Fh8QAmvZht7+0XEKTUs34RYr6WIo9Mj3StBD3/iJjKDgPSLoDCTih//00jRM+ljIPvKpjz8/vKe7zUEAul0YIapUPf7XWRDXiKdIrENgmth7d72kuloTYASRLQxC+vN+0Yea4SL41ZwPzcWH51J9Wag1RCEo97pqdgvAjIy3dL3FUKLw+NOtf8GTS5h52ZT8clqL3ehZ16I61CqO/AKlhihRSKzsD3a1ZwHCkGSjkT6EMmiWGy1SloBZAGAXiIzKJAhAq8onBDKkfVjiHBCUT7UBjBLwZY1AvI8jHUN7ScF54418ppaYgL9jNbuh5iHxqoItCop8b+BLEAQAgIfyWrnoxJbgFDDlQVaeWuwuuiSs8qVZd+XAxD/C8hWCj0BHtUEzF7qSVeWM5War9Q5AGg/l75bv1hvltwV7VC5oN9TE/A3KV9OlBtK8w5sG4Eugbr1XwFW80b9YniNQCsXCBBQJNaZmPI3TDCC1YZluNVAYQzgO22ETxwluy246V9pKsoZyxc/AG0L8dkxiWW5AAAAAElFTkSuQmCC">',
      email_address:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABKUlEQVQokZWRu06CURCEvzlgRAt7emhtRGwpsMPaRCW8gRECpR2RAiQaLy9gLOyx0Epb4E8sNWDpO2D4OWvBRYmGxOl2d/Yys/BP6GeQKAc7YCVgEwCjLadmr77RmnLcN7l7AnYl2WXEDeIRN4ibdOHNGslyUJ1rGE/mIJRPe+/SoY+9jXzsVdjWSD5jWCFZCXIA0XGflSQrRs0dIb8OOkcIIzPOUTKzItCanpRy+nwE8kjPiH1gD/EE5BmED1NdMw1/wtgFlv1qdGZOdFLohH4lK+wGIwPcgj4wW3MR68qTNdSZbZBTE6wWyp8BL8Ah+ET/NHW9NBz2zVQTNOf+kCwHVcMKiNLkZhSLbJupZuLuvZ46/vW4ZCXITdxIT1JtQbPXSN0v1LoIX2kXdx1+DScXAAAAAElFTkSuQmCC">',
      phone_number:
        '<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABmJLR0QA/wD/AP+gvaeTAAABU0lEQVQokXWRu04CURCG/zlnhYhySUjsTIhZoCARJaKN+BRGWyoLExIU8A20UELpA1iila+gDXITEwrBzhgrjFxN3N0zVktWol/3/zNfM0NwEDtsLw591pyz8w6k0b6MjexMAKAfV9dB2IWgIRjsFEAgKPaS4OvuxeYjAEDPVU8BIHJUXQnnGjv4Az1fOwMAoWe6bgZ9hLLNgJJ0oIij4Xxta1ZgRk/PdN1iEuxLAiu3a2wR493Q5m4UODkrEFhNgn0p7OL5fHvI4CVpGsuCxGhWsNGcQbAsQ3BKgefDhXoazD4AlW5xozLdcQqdUqIFS70S6MtkNAxTXimmeKRQT00FT89vMWgqvpSStxbjTrLa1zSVJuIQTPXGIOHp+a1fZ50lenLvDWWbAedZCQDChYc1ZrEHwuC/xwmW5U4p0SLnbDXfWvjUyOXsAiZ/PxXjYzv/ANuDiceD1JT8AAAAAElFTkSuQmCC">',
    };

    return icons;
  }

  leftPanelFiltersObjectsLoader(filters, filter_type) {
    console.log("leftPanelFiltersObjectsLoader function called");

    var jobs_filter_obj = {
      upload_new_jd: [],
      create_new_job: [],
      view_all_jobs: [],
    };
    var org_chart_filters_obj = {
      website: [],
      company_name: [],
      company_id: [],
      function_root: [],
      country: [],
      company_linkedin_url: [],
    };
    var company_filters_obj = {
      gpt3_company_search: [],
      company_name: [],
      company_id: [],
      industry_category: [],
      industry: [],
      reverse_company: [],
      website: [],
      company_linkedin_url: [],
      function_root: [],
      company_sizes: [],
      country: [],
      region: [],
      locality: [],
      locality_presence: [],
      country_presence: [],
      region_presence: [],
      company_type: [],
      founded: [],
      tags: [],
    };
    var people_filters_obj = {
      gpt3_company_search: [],
      reverse_job_title: [],
      company_id: [],
      company_name: [],
      functions: [],
      function_root: [],
      grades: [],
      reverse_company: [],
      skills: [],
      locations: [],
      country: [],
      region: [],
      locality: [],
      person_name: [],
      person_linkedin_url: [],
      email_address: [],
      phone_number: [],
      genders: [],
      company_sizes: [],
      industry: [],
      industry_category: [],
      school: [],
      education_degrees: [],
      education_majors: [],
      year_of_graduation: [],
    };
    var reverse_people_search_filters_obj = {
      company_name: [],
      job_title: [],
      locations: [],
    };

    if (filter_type == "orgcharts") {
      var display_objs = {
        company_name: "Company Name",
        company_id: "Linkedin Company Ids",
        job_title: "Job Title",
        industry: "Industry",
        functions: "Functions",
        function_root: "Functional Area",
        grades: "Seniority",
        locations: "Locations",
        country: "Country",
        genders: "Genders",
        company_linkedin_url: "Company Linkedin URL",
        website: "Website",
        search_in_org_chart: "Search Current Org Chart",
      };
      var filters = Object.keys(org_chart_filters_obj);
    }
    if (filter_type == "jobs") {
      var display_objs = {
        upload_new_jd: "Upload new JD",
        create_new_job: "Create New Job",
        view_all_jobs: "View all jobs",
      };
      var filters = Object.keys(jobs_filter_obj);
    } else if (filter_type == "companies") {
      var display_objs = {
        company_name: "Company Name",
        gpt3_company_search: "GPT3 Company Search",
        company_id: "Linkedin Company Id",
        reverse_company: "Reverse Company Search",
        function_root: "Functions",
        description: "Description",
        tags: "Tags",
        region: "State/ Region",
        company_type: "Company Type",
        company_sizes: "Company Sizes",
        revenue: "Revenue",
        founded: "Year Founded",
        industry: "Industry",
        industry_category: "Industry Category",
        functions: "Functions",
        company_linkedin_url: "Company Linkedin URL",
        employee_count: "Employee Counts",
        website: "Website",
        grades: "Seniority",
        locations: "Locations",
        locality: "City/ Locality",
        locality_presence: "Presence - Locality",
        country_presence: "Presence - Country",
        region_presence: "Presence - Region",
        country: "Country",
        naics: "NAICS",
      };
      var filters = Object.keys(company_filters_obj);
      console.log();
    } else if (filter_type == "people") {
      // people_filters_obj = {'industry': [],'job_title': [],'company_name': [],'functions': [],'grades': [],'school': [],'locations': [],'gender': []}
      var display_objs = {
        company_name: "Company Name",
        gpt3_company_search: "GPT3 Company Search",
        company_id: "Linkedin Company Id",
        person_name: "Person Name",
        job_title: "Job Title",
        reverse_job_title: "Similar Job Titles",
        reverse_company: "Preceding Companies",
        region: "State/ Region",
        locality: "City/ Locality",
        industry: "Industry",
        industry_category: "Industry Category",
        functions: "Functions",
        function_root: "Functional Area",
        grades: "Seniority",
        skills: "Skills",
        locations: "Locations",
        country: "Country",
        school: "Schools",
        genders: "Genders",
        person_linkedin_url: "Person Linkedin URL",
        inferred_salary: "Salary",
        company_sizes: "Company Sizes",
        education_degrees: "Degrees",
        education_majors: "Majors",
        email_address: "Email",
        phone_number: "Phone",
        year_of_graduation: "Year of Graduation",
      };
      var filters = Object.keys(people_filters_obj);
    } else if (filter_type == "reverse_people") {
      var display_objs = {
        company_name: "Company Name",
        job_title: "Job Title",
        locations: "Locations",
      };
      var filters = Object.keys(reverse_people_search_filters_obj);
    }

    var icons = this.getIcons();
    var tooltip_texts = this.getTooltipTexts();

    // will set this up later separately
    var premium_filters = ["genders", "function_root", "functions", "grades", "email_address", "phone_number", "reverse_company", "reverse_job_title", "gpt3_company_search"];
    // premium_filters = ['company_name','industry','tags']
    var raw_text_filters = JSON.parse(sessionStorage["raw_text_filters"]);
    var filter_rows = "";
    console.log(filters);
    for (var i = 0; i < filters.length; i++) {
      if (premium_filters.includes(filters[i])) {
        var premium_icon =
          '<svg class="svg-inline--fa fa-crown fa-w-20 me-1" data-toggle="tooltip" data-original-title="Premium Fields"  role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path fill="#f5803e" d="M528 448H112c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h416c8.8 0 16-7.2 16-16v-32c0-8.8-7.2-16-16-16zm64-320c-26.5 0-48 21.5-48 48 0 7.1 1.6 13.7 4.4 19.8L476 239.2c-15.4 9.2-35.3 4-44.2-11.6L350.3 85C361 76.2 368 63 368 48c0-26.5-21.5-48-48-48s-48 21.5-48 48c0 15 7 28.2 17.7 37l-81.5 142.6c-8.9 15.6-28.9 20.8-44.2 11.6l-72.3-43.4c2.7-6 4.4-12.7 4.4-19.8 0-26.5-21.5-48-48-48S0 149.5 0 176s21.5 48 48 48c2.6 0 5.2-.4 7.7-.8L128 416h384l72.3-192.8c2.5.4 5.1.8 7.7.8 26.5 0 48-21.5 48-48s-21.5-48-48-48z"></path></svg>';
      } else {
        var premium_icon = "";
      }

      var filter_row_elem = document.getElementById("filter_element").innerHTML;
      filter_rows =
        filter_rows +
        filter_row_elem
          .replaceAll("{filter_id}", filters[i])
          .replace("{icon}", icons[filters[i]])
          .replaceAll("{filter_name}", display_objs[filters[i]])
          .replace("{tooltip_text}", tooltip_texts[filters[i]])
          .replace("{filter_input_filter_id_}", "filter_input_filter_id_" + filters[i])
          .replace("{search_selection_tokens_id_}", "search_selection_tokens_id_" + filters[i])
          .replace("{clear_filter_input_filter_id_}", "clear_filter_input_filter_id_" + filters[i])
          .replace("{premium_icon}", premium_icon);
    }

    document.getElementById("left_search_filters").innerHTML = filter_rows;

    for (var i = 0; i < filters.length; i++) {
      // load objects with raw text
      // console.log(filters[i])
      if (["email_address", "phone_number"].includes(filters[i])) {
      } else {
        document.getElementById("checkbox_check_has_" + filters[i]).innerHTML = "";
      }
      if (["company_name", "company_id", "industry", "website"].includes(filters[i])) {
        document.getElementById("clear_filter_input_filter_id_" + filters[i]).innerHTML =
          "<label onclick=ClearFiltersPanel(this) id=clear_filters_" + filters[i] + ' class=" prospecting-style-tag-filters-97ijzq-placeholder" for="clear_filter_item">Clear</label>';
      } else {
      }
      if (raw_text_filters.includes(filters[i])) {
        var filter_inputs_raw = "";
        var filter_input_raw_text_elem = document.getElementById("filters_input_element_raw_text").innerHTML;
        var filter_inputs_raw = filter_inputs_raw + filter_input_raw_text_elem.replaceAll("{left_filter_input_id_}", "left_filter_input_id_" + filters[i]).replace("{input_search_field}", filters[i]);
        document.getElementById("filter_input_filter_id_" + filters[i]).innerHTML = filter_inputs_raw;
      } else {
        // console.log("Going here to create filter left panel")
        // load objects with dropdown texts
        var filter_inputs = "";
        var filter_input_elem = document.getElementById("filters_input_element").innerHTML;
        var filter_inputs =
          filter_inputs +
          filter_input_elem
            .replaceAll("{left_filter_input_id_}", "left_filter_input_id_" + filters[i])
            .replace("{filters_autocomplete_dropdown_}", "filters_autocomplete_dropdown_" + filters[i])
            .replace("{input_search_field}", filters[i]);
        // .replace("{filters_autocomplete_dropdown_list_}", "filters_autocomplete_dropdown_list_"+filters[i])
        document.getElementById("filter_input_filter_id_" + filters[i]).innerHTML = filter_inputs;
      }
      $("#left_filter_input_id_" + filters[i]).on("click", function (e) {
        console.log("Got to filter id website prop:");
        e.stopPropagation();
      });

      $("#filter_input_filter_id_" + filters[i]).on("click", function (e) {
        console.log("Got to filter id filter_input_filter_id_ prop:");
        e.stopPropagation();
      });
    }

    try {
      console.log("Going to try to do this and load the filter inputs functions left panel using comboox");
      document.getElementById("filter_input_filter_id_functions").innerHTML = '<input type="text" id="comboBoxTree" placeholder="Enter Functions" class="comboTreeInputBox">';
      var input_box_id_combotree = "comboBoxTree";
      var comboTree1 = new ComboTreeBox().loadComboTree(input_box_id_combotree);
      new ComboTreeBox().executeCleanupCombobox();
      var multiples_input_id = document.getElementsByClassName("multiplesFilter")[0].id;
      console.log("Got here to do multiples input id::::", multiples_input_id);
      $("#" + multiples_input_id).on("click", function (e) {
        console.log("Got to filter id functional dropdown prop:");
        e.stopPropagation();
      });
      // $('#multiplesFilter').on('click', function(e){
      //     console.log("Got to filter id functional dropdown prop:");
      //     e.stopPropagation();
      // });
    } catch (error) {
      // console.log("Error:",error)
    }

    try {
      // $('[data-toggle="tooltip"]').tooltip({ placement : 'top'});
      new UtilityFunctions().activateToolTips();
    } catch (error) {
      console.log("Error:", error);
    }

    for (var i = 0; i < filters.length; i++) {
      new LeftPanelDropdownFilters().makeInVisibleLeftPanelFilterDropDownElement(filters[i]);
      sessionStorage["isOpenPlusMinusFilter_" + filters[i]] = "no";
    }
  }

  loadFiltersPanel(filter_type) {
    if (filter_type == "orgcharts") {
      // org_chart_filters = ['company_name','functions', 'grade', 'position', 'year founded', 'country', 'location', 'linkedin url', 'gender', 'job title']
      var org_chart_filters = Object.keys(org_chart_filters_obj);
      if (sessionStorage["query"] == "{}") {
        // only at initialization
        new ProcessNodesStates().initializeSessionStorageforDropdowns();
      }
      this.leftPanelFiltersObjectsLoader(org_chart_filters, filter_type);
    } else if (filter_type == "companies") {
      var company_filters = Object.keys(company_filters_obj);
      if (sessionStorage["query"] == "{}") {
        // only at initialization
        new ProcessNodesStates().initializeSessionStorageforDropdowns();
      }
      this.leftPanelFiltersObjectsLoader(company_filters, filter_type);
    } else if (filter_type == "jobs") {
      var jobs_filter_obj = {
        upload_new_jd: [],
        create_new_job: [],
        view_all_jobs: [],
      };
      var jobs_filters = Object.keys(jobs_filter_obj);
      this.leftPanelFiltersObjectsLoader(jobs_filters, filter_type);
    } else {
      var people_filters = Object.keys(people_filters_obj);
      if (sessionStorage["query"] == "{}") {
        // only at initialization
        new ProcessNodesStates().initializeSessionStorageforDropdowns();
      }
      this.leftPanelFiltersObjectsLoader(people_filters, filter_type);
    }
  }

  updateLeftPanelWithNewTokensforArxenaReversed(response) {
    console.log("Response results source is arxena_reversed:::", response);
    // if (response['results']['data']['gpt3_company_search'].length>0){
    if (typeof response["results"]["data"]["gpt3_company_search"] == "object") {
      if (response["results"]["data"]["gpt3_company_search"].length > 0) {
        var token_obj = {};
        const [company_ids_arr, company_names_arr] = new DrawOrgCharts().companyIdsNamesFromResponseObj(response);
        token_obj["companies_ids_list"] = company_ids_arr;
        token_obj["companies_names_list"] = company_names_arr;
        updateStorageToken(token_obj, "gpt3_company_search");
        new Tokens().showTokensinUI();
      }
    } else if (response["results"]["data"]["results_source"] == "industry_category") {
      if (response["results"]["data"]["modified_query_results"]["results"]["data"].length > 0) {
        var token_obj = {};
        var industry_arr = response["results"]["data"]["modified_query_results"]["results"]["data"];
        token_obj["industry_category"] = industry_arr;
        updateStorageToken(token_obj, "industry_category");
        new Tokens().showTokensinUI();
      }
    } else {
      var token_obj = {};
      token_obj["functions"] = response["results"]["data"]["modified_query_results"]["results"]["reversed_data"]["functions_arr"];
      token_obj["grades"] = response["results"]["data"]["modified_query_results"]["results"]["reversed_data"]["grades_arr"];
      token_obj["companies_ids_list"] = response["results"]["data"]["modified_query_results"]["results"]["reversed_data"]["companies_ids_list"];
      // token_obj['companies__list'] = response['results']['data']['modified_query_results']['results']['reversed_data']['companies_names_list']
      updateStorageToken(token_obj, "arxena_reversed");
      new Tokens().showTokensinUI();
    }
  }

  makeVisibleLeftPanelFilterDropDownElement(filter_id) {
    console.log("Got to makeVisibleLeftPanelFilterDropDownElement for filter id", filter_id);
    sessionStorage["isOpenPlusMinusFilter_" + filter_id] = "yes";
    try {
      document.getElementById("label-select-icon-" + filter_id).setAttribute("style", "display:none");
      // document.getElementById("prospecting-style-tag-filters-container-"+filter_id).style.display = ""
      document.getElementById("prospecting-style-tag-filters-container-" + filter_id).setAttribute("style", "");
      document.getElementById("label-select-" + filter_id).style.width = "250px";
      setTimeout("new LeftPanelDropdownFilters().setAttributeofFilterToggleToNotExist('" + filter_id + "');", 500);
    } catch {}
    // document.getElementById("label-select-icon-"+filter_id).style.display = ""
    // document.getElementById("plus_minus_icon_autocomplete_dropdown_"+filter_id).innerHTML = '<svg id = "minus_icon_autocomplete_dropdown_{filter_id}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" height="16" width="16" style="cursor:pointer;"><rect fill="#151417" rx="1" height="2" width="10" y="7" x="3"></rect></svg>'
    // document.getElementById("filter_id_"+filter_id).setAttribute("onclick","")

    // document.getElementById("plus_minus_icon_autocomplete_dropdown_left_filter_input_id_"+filter_id).innerHTML = '<svg id = "minus_icon_autocomplete_dropdown_{left_filter_input_id_}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" height="16" width="16" style="margin-left:180px;cursor:pointer;"><rect fill="#151417" rx="1" height="2" width="10" y="7" x="3"></rect></svg>'
  }

  makeInVisibleLeftPanelFilterDropDownElement(filter_id) {
    // console.log("Got to makeInVisibleLeftPanelFilterDropDownElement for filter id",filter_id )
    try {
      // console.log("Try catch if login is not true")
      sessionStorage["isOpenPlusMinusFilter_" + filter_id] = "no";

      // document.getElementById("label-select-icon-"+filter_id).style.display = "none"
      // document.getElementById("prospecting-style-tag-filters-container-"+filter_id).style.display = "none"
      document.getElementById("label-select-icon-" + filter_id).setAttribute("style", "display:none");
      document.getElementById("prospecting-style-tag-filters-container-" + filter_id).setAttribute("style", "display:none");
      document.getElementById("label-select-" + filter_id).style.width = "250px";
      // document.getElementById("plus_minus_icon_autocomplete_dropdown_"+filter_id).innerHTML = '<svg id = "plus_icon_autocomplete_dropdown_{filter_id}" xmlns="http://www.w3.org/2000/svg" height="16" width="16" style="cursor:pointer;"> <path fill="#343a40" d="M8 3.0004C7.44772 3.0004 7 3.44811 7 4.0004V7.0004L4 7.0004C3.44772 7.0004 3 7.44811 3 8.0004C3 8.55268 3.44772 9.0004 4 9.0004H7V12.0004C7 12.5527 7.44772 13.0004 8 13.0004C8.55228 13.0004 9 12.5527 9 12.0004V9.0004H12C12.5523 9.0004 13 8.55268 13 8.0004C13 7.44811 12.5523 7.0004 12 7.0004L9 7.0004V4.0004C9 3.44811 8.55228 3.0004 8 3.0004Z" clip-rule="evenodd" fill-rule="evenodd"></path> </svg>'

      setTimeout("new LeftPanelDropdownFilters().setAttributeofFilterToggleToExist('" + filter_id + "');", 500);
    } catch (error) {
      console.log("Error:", error);
    }
    // document.getElementById("plus_minus_icon_autocomplete_dropdown_left_filter_input_id_"+filter_id).innerHTML = '<svg id = "plus_icon_autocomplete_dropdown_{left_filter_input_id_}" xmlns="http://www.w3.org/2000/svg" height="16" width="16" style="margin-left:180px;cursor:pointer;"> <path fill="#343a40" d="M8 3.0004C7.44772 3.0004 7 3.44811 7 4.0004V7.0004L4 7.0004C3.44772 7.0004 3 7.44811 3 8.0004C3 8.55268 3.44772 9.0004 4 9.0004H7V12.0004C7 12.5527 7.44772 13.0004 8 13.0004C8.55228 13.0004 9 12.5527 9 12.0004V9.0004H12C12.5523 9.0004 13 8.55268 13 8.0004C13 7.44811 12.5523 7.0004 12 7.0004L9 7.0004V4.0004C9 3.44811 8.55228 3.0004 8 3.0004Z" clip-rule="evenodd" fill-rule="evenodd"></path> </svg>'
  }

  setAttributeofFilterToggleToExist(filter_id) {
    // console.log("Try catch if login is not true")
    try {
      // document.getElementById("filter_id_"+filter_id).setAttribute("onclick","this.togglePlusIconMinusIcon(this)")
    } catch (error) {
      console.log("Error:", error);
    }
  }

  setAttributeofFilterToggleToNotExist(filter_id) {
    // console.log("Try catch if login is not true")
    try {
      // document.getElementById("filter_id_"+filter_id).setAttribute("onclick","")
    } catch (error) {
      console.log("Error:", error);
    }
  }

  leftPanelJobsFiltersClicked(element_id_clicked) {
    if (element_id_clicked == "view_all_jobs") {
      new PageContents().changePage("/lists");
    }
    if (element_id_clicked == "create_new_job") {
      new Modals().addNewJobModal();
    }
    if (element_id_clicked == "upload_new_jd") {
      new UploadJDCVTopBar().uploadJD();
      sessionStorage["current_job"] = "";
    }
  }

  togglePlusIconMinusIcon(user_input) {
    console.log("Called togglePlusIconMinusIcon wiwht user input::", user_input);
    if (user_input.getAttribute("id").includes("filter_id_")) {
      var element_id_clicked = user_input.getAttribute("id").replace("filter_id_", "");
      if (["create_new_job", "view_all_jobs", "upload_new_jd"].includes(element_id_clicked)) {
        this.leftPanelJobsFiltersClicked(element_id_clicked);
      }
    } else {
      var element_id_clicked = user_input.getAttribute("id").replace("plus_minus_icon_autocomplete_dropdown_", "");
    }
    if (user_input.getAttribute("id").includes("left_filter_input_id_")) {
      var element_id_clicked = user_input.getAttribute("id").replace("left_filter_input_id_", "");
    }
    console.log("This is the element_id_clicked", element_id_clicked);
    if (sessionStorage["isOpenPlusMinusFilter_" + element_id_clicked] == "no") {
      this.makeVisibleLeftPanelFilterDropDownElement(element_id_clicked);
    } else {
      this.makeInVisibleLeftPanelFilterDropDownElement(element_id_clicked);
    }
  }
}

class DragDropdJDFile {
  // Function to display upload success message
  showUploadSuccessMessage(data) {
    const uploadStatus = document.getElementById("upload-status");
    uploadStatus.textContent = "File uploaded successfully. Sending to server...";
    setTimeout("new DragDropdJDFile().showUploadCompleteMessage()", 500);
    // var job_data = this.uploadJDFetchJobDataObj()
    // debugger;
    var job_data = data["results_obj"]["job_obj"];
    // var job_data = {"table_id":"c1c39179066e43a1aaec467b5903e1f7","table_name":"chart-sugar-cosmetics"}
    // debugger;
    if (data["results_obj"]["status"] != "blank") {
      sessionStorage["current_table"] = JSON.stringify(job_data);
      new PageContents().changePage("/tables");
    } else {
      new Pages().switchAllContentToSearchPage();
      new PageContents().changePage("/lists");
    }
  }
  //  to display upload progress message
  showUploadProgressMessage(progress) {
    const uploadStatus = document.getElementById("upload-status");
    const uploadProgress = document.getElementById("upload-progress");
    uploadStatus.textContent = `Uploading: ${progress}%`;
    uploadProgress.style.width = `${progress}%`;
    uploadProgress.style.display = "block";
  }
  showUploadCompleteMessage() {
    try {
      const uploadStatus = document.getElementById("upload-status");
      uploadStatus.textContent = "Upload complete!";

      // Clear the file input
      const fileInput = document.getElementById("file-input");
      fileInput.value = ""; // This will clear the selected file(s) from the input
    } catch {}
  }
  setupEventListeners() {
    // Get references to necessary HTML elements
    // Get references to necessary HTML elements
    const dropZone = document.getElementById("home_page_upload_job_description_dropdown_element");
    const fileInput = document.getElementById("file-input"); // Add this line

    // Prevent the default behavior of drag-and-drop events
    dropZone.addEventListener("dragenter", (e) => {
      e.preventDefault();
      dropZone.classList.add("drag-over");
    });

    // Prevent the default behavior of drag-and-drop events
    dropZone.addEventListener("dragenter", (e) => {
      e.preventDefault();
      dropZone.classList.add("drag-over");
    });

    dropZone.addEventListener("dragover", (e) => {
      e.preventDefault();
      dropZone.classList.add("drag-over");
    });

    dropZone.addEventListener("dragleave", () => {
      dropZone.classList.remove("drag-over");
    });

    dropZone.addEventListener("drop", (e) => {
      e.preventDefault();
      dropZone.classList.remove("drag-over");

      const file = e.dataTransfer.files[0];
      this.handleFileUpload(file);
    });

    fileInput.addEventListener("change", (e) => {
      const selectedFile = e.target.files[0];
      this.handleFileUpload(selectedFile);
    });

    // Add a click event listener to the label element to open the file dialog
    document.getElementById("file-label")?.addEventListener("click", (e) => {
      e.preventDefault();
      fileInput.click(); // Trigger the file input click event
    });
  }
  // Function to handle file upload
  async handleFileUpload(file) {
    console.log("handle file upload function called");
    if (file) {
      var loader = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/></div>Parsing your JD & Fetching Relevant Candidates. Takes upto 1 minute. Please wait, do not click anywhere!';
      document.getElementById("upload-status").innerHTML = loader;
      console.log("File is present");
      var post_request_url = base_url + "/upload_jd";
      var formdata = new FormData();
      formdata.append("file", file);
      try {
        const response = await fetch(post_request_url, { method: "POST", body: formdata });
        var data = await response.json();
        if (data["status"] === "success") {
          console.log("received data successfully. this is the data::", data);
          this.showUploadSuccessMessage(data);
        }
        console.log("Response sendChatToBackendGetResponse:", data);
        return data;
      } catch (error) {
        if (error?.message?.includes("signed out")) {
          new PageContents().tokenExpireAction();
        } else {
          console.log("have caughgt an error bosssss");
          document.getElementById("upload-status").innerText = "There has been an error. \n Please email us at info@arxena.com \n Please retry after sometime.";
          setTimeout("document.getElementById('home_page_jd_dropdown_element').innerHTML = '';", 1000);
          console.log("Error:", error);
        }
      }
    }
  }
}

class SearchBarLoadersDropdowns {
  placeDropdownBelowSearchforJDInput() {
    console.log("Clicking to get the dropdown below the search for jd input");
    var jdDropdown = document.getElementById("home_page_jd_dropdown_element");
    var uploadElement = document.getElementById("front_page_upload_jd_element");
    if (jdDropdown && uploadElement) jdDropdown.innerHTML = uploadElement.innerHTML;
    window.addEventListener("click", function (e) {
      var buttonDropdown = document.getElementById("button_dropdown_search_jd");
      if (buttonDropdown?.contains(e.target)) {
        // Clicked in box
      } else {
        try {
          var jdDropdownEl = document.getElementById("home_page_jd_dropdown_element");
          if (!jdDropdownEl) return;
          if (jdDropdownEl.contains(e.target)) {
            // Clicked in box
          } else {
            jdDropdownEl.innerHTML = "";
          }
        } catch (error) {
          console.log("Error:", error);
        }
      }
    });
    // Also setting up event listeners for file uplaod
    new DragDropdJDFile().setupEventListeners();
  }

  documentInputElemOnblur(user_input) {
    console.log("document input on blur with user input::");
    // Keep names elem_focussed different from element focussed because when cliked where variable value changes, it gets reset
    var elem_focussed = user_input.id.replace("left_filter_input_id_", "");
    document.getElementById("left_filter_input_id_" + elem_focussed).value = "";
    console.log("This is element focessed::", elem_focussed);
    // document.getElementById("input_enter_text_"+elem_focussed).innerHTML = "Enter "+elem_focussed
    // document.getElementById("filters_autocomplete_dropdown_"+element_focussed).innerHTML = ""

    window.addEventListener("click", function (e) {
      try {
        var filterDropdown = document.getElementById("filters_autocomplete_dropdown_" + elem_focussed);
        if (!filterDropdown) return;
        if (filterDropdown.contains(e.target)) {
          filterDropdown.innerHTML = "";
        } else {
          filterDropdown.innerHTML = "";
        }
      } catch (error) {
        console.log("Error:", error);
      }
    });

    document.addEventListener("keydown", function (e) {
      if (e.keyCode == 27) {
        try {
          var filterDropdown = document.getElementById("filters_autocomplete_dropdown_" + elem_focussed);
          if (!filterDropdown) return;
          if (filterDropdown.contains(e.target)) {
            // Clicked in box
          } else {
            filterDropdown.innerHTML = "";
          }
        } catch (error) {
          console.log("Error:", error);
        }
      }
    });
  }

  addEventListenerHomePageInputElementOnBlur() {
    window.addEventListener("click", function (e) {
      try {
        var dropdown = document.getElementById("home_page_dropdown_elements");
        if (!dropdown) return;
        if (dropdown.contains(e.target)) {
          // Clicked in box
        } else {
          dropdown.innerHTML = "";
          dropdown.style.display = "none";
        }
      } catch (error) {
        console.log("Error:", error);
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.keyCode == 27) {
        try {
          var elemFocussed = window.element_focussed;
          var filterDropdown = elemFocussed && document.getElementById("filters_autocomplete_dropdown_" + elemFocussed);
          if (!filterDropdown) return;
          if (filterDropdown.contains(e.target)) {
            // Clicked in box
          } else {
            filterDropdown.innerHTML = "";
          }
        } catch (error) {
          console.log("Error:", error);
        }
      }
    });
  }

  homePageInputElemOnblur() {
    console.log("document input on blur: with user intput::");
    // element_focussed = user_input.id.replace('left_filter_input_id_','')
    var homeDropdown = document.getElementById("home_page_dropdown_elements");
    var searchBar = document.getElementById("search_bar_front_page");
    var searchBarMobi = document.getElementById("search_bar_front_page_mobi");
    if (homeDropdown) homeDropdown.value = "";
    if (searchBar) searchBar.value = "";
    if (searchBarMobi) searchBarMobi.value = "";

    window.addEventListener("click", function (e) {
      try {
        var dropdown = document.getElementById("home_page_dropdown_elements");
        if (!dropdown) return;
        if (dropdown.contains(e.target)) {
          // Clicked in box
        } else {
          dropdown.innerHTML = "";
        }
      } catch (error) {
        console.log("Error:", error);
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.keyCode == 27) {
        try {
          var elemFocussed = window.element_focussed;
          var filterDropdown = elemFocussed && document.getElementById("filters_autocomplete_dropdown_" + elemFocussed);
          if (!filterDropdown) return;
          if (filterDropdown.contains(e.target)) {
            // Clicked in box
          } else {
            filterDropdown.innerHTML = "";
          }
        } catch (error) {
          console.log("Error:", error);
        }
      }
    });
  }

  updateStorageTokensWithNewClientStorageObjAndLoadData(data) {
    console.log("Got to updateStorageTokensWithNewClientStorageObjAndLoadData:: with data::", data);
    sessionStorage["current_focus"] = data["params_obj"]["current_focus"];
    sessionStorage["query"] = JSON.stringify(data["query_obj"]);
    new Pages().setAllContentLoginLogout();
    new Tokens().updateDataBasedonChangedTokens();
  }

  updateHomePageSearchRawTextKeyword(user_input) {
    console.log("Called updateHomePageSearchRawTextKeyword");
    if (user_input.value != "") {
      document.getElementById("error_home_page").innerText = "";
      document.getElementById("error_home_page").style.display = "none";
      var loader = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/>';
      // window.location.href.includes('org-chart') ? showSearchPageSearchBarLoader() :
      if (window.location.href.includes("people") || window.location.href.includes("companies") || window.location.href.includes("org-chart")) {
        this.showSearchPageSearchBarLoader();
      } else {
        this.showFrontPageSearchBarLoader();
      }
      // console.log(user_input)
      console.log("This is the raw text::", user_input.value);
      var input_text = user_input.value;
      sessionStorage["home_page_input_raw_text_token"] = input_text;
      setTimeout("new SearchBarLoadersDropdowns().getDataRawTextHomePageSearch('" + input_text + "');", 500);
    } else {
      document.getElementById("error_home_page").style.display = "block";
      document.getElementById("error_home_page").innerText = "Please type a query";
    }
  }

  getDataRawTextHomePageSearch() {
    var chat_message = sessionStorage["home_page_input_raw_text_token"];
    var auth_token = Cookies.getJSON()["auth_token"];
    var query_obj = {
      chat_message: chat_message,
      auth_token: auth_token,
      source: "home_page",
    };
    $.ajax({
      url: "/raw_string",
      type: "POST",
      headers: { "Content-Type": "application/json" },
      data: JSON.stringify(query_obj),
      error: function (xhr, status) {
        var error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
        console.log("Error Status:", error_status);
        return {};
        // alert(xhr.status);
      },
    }).done(function (data) {
      console.log("Received Data!!", data);
      new SearchBarLoadersDropdowns().updateStorageTokensWithNewClientStorageObjAndLoadData(data);
    });
  }

  searchPageInputElemOnblur(user_input) {
    console.log("document input on blur");
    var centerDropdown = document.getElementById("search_page_center_dropdown_elements");
    var centerDropdownMobi = document.getElementById("search_page_center_dropdown_elements_mobi");
    var searchBar = document.getElementById("search_bar_search_center");
    var searchBarMobi = document.getElementById("search_bar_search_center_mobi");
    if (centerDropdown) centerDropdown.value = "";
    if (centerDropdownMobi) centerDropdownMobi.value = "";
    if (searchBar) searchBar.value = "";
    if (searchBarMobi) searchBarMobi.value = "";
    window.addEventListener("click", function (e) {
      try {
        var dropdown = document.getElementById("search_page_center_dropdown_elements");
        var dropdownMobi = document.getElementById("search_page_center_dropdown_elements_mobi");
        if (dropdown) {
          if (dropdown.contains(e.target)) dropdown.innerHTML = "";
          else dropdown.innerHTML = "";
        }
        if (dropdownMobi) {
          if (dropdownMobi.contains(e.target)) dropdownMobi.innerHTML = "";
          else dropdownMobi.innerHTML = "";
        }
      } catch (error) {
        console.log("Error:", error);
      }
    });
    document.addEventListener("keydown", function (e) {
      if (e.keyCode == 27) {
        try {
          var elemFocussed = window.element_focussed;
          var filterDropdown = elemFocussed && document.getElementById("filters_autocomplete_dropdown_" + elemFocussed);
          if (!filterDropdown) return;
          if (filterDropdown.contains(e.target)) {
            // Clicked in box
          } else {
            filterDropdown.innerHTML = "";
          }
        } catch (error) {
          console.log("Error:", error);
        }
      }
    });
  }

  getDataLoadAutocompleteDropdown(input_field_obj) {
    var input_field_obj = JSON.parse(input_field_obj);
    var input_field_focussed_id = input_field_obj.input_field_focussed_id;
    var input_text = input_field_obj.user_input;
    console.log("Got this ::", input_field_obj);
    var element_focussed = input_field_focussed_id.replace("left_filter_input_id_", "");

    document.getElementById("filters_autocomplete_dropdown_" + element_focussed).innerHTML = document
      .getElementById("filters_autocomplete_dropdown_element")
      .innerHTML.replace("{filters_autocomplete_dropdown_list_}", "filters_autocomplete_dropdown_list_" + element_focussed);
    var raw_text_filters = JSON.parse(sessionStorage["raw_text_filters"]);
    if (input_text == sessionStorage["new_input_text_token"] && !raw_text_filters.includes(element_focussed)) {
      var params_obj = updateParamsObj();

      console.log("This is the params obj:: ", params_obj);
      console.log("This is the query::: ", sessionStorage["query"]);
      // debugger;
      $.ajax({
        url: "/filters",
        type: "POST",
        data: {
          input_text: input_text,
          element_focussed: element_focussed,
          params: params_obj,
          query: sessionStorage["query"],
        },
        error: function (xhr, status) {
          var error_status = xhr.status;
          if (error_status == 599) {
            new PageContents().tokenExpireAction();
          }
          if (error_status == 429) {
            console.log("Too Many Requests");
            document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
            document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
          }
          if (error_status == 500) {
            console.log("There has been an error in the autocomplete query");
          }
        },
      }).done(function (response) {
        console.log("ajax called response", response);
        if (response?.status && response.status == "ok") {
          let data = response.result;
          new SearchBarLoadersDropdowns().showDropDownList(element_focussed, data);
        } else {
          console.error("when / filters called got this response::", response);
          new PageContents().logOut();
        }
      });
    }
    console.log("NO FILTERS REQUEST SENT");
  }
  getDataLoadAutocompleteDropdownCustom(input_field_obj) {
    var element_focussed = input_field_obj.element_focussed;
    var input_text = input_field_obj.user_input;
    console.log("Got this ::", input_field_obj);

    if (input_text == sessionStorage["onKeypressInput"]) {
      var params_obj = updateParamsObj();

      console.log("This is the params obj:: ", params_obj);
      console.log("This is the query::: ", sessionStorage["query"]);
      // debugger;
      $.ajax({
        url: "/filters",
        type: "POST",
        data: {
          input_text: input_text,
          element_focussed: element_focussed,
          params: params_obj,
          query: sessionStorage["query"],
        },
        error: function (xhr, status) {
          var error_status = xhr.status;
          if (error_status == 429) {
            console.log("Too Many Requests");
          }
          if (error_status == 599) {
            new PageContents().tokenExpireAction();
          }
          if (error_status == 500) {
            console.log("There has been an error in the autocomplete query");
          }
        },
      }).done(function (response) {
        console.log("This is the AJAX response ", response);
        if (response?.status && response.status == "ok") {
          let data = response.result;
          new SearchBarLoadersDropdowns().showDropDownListCustom(element_focussed, data);
        } else {
          console.error("when / filters called got this response::", response);
          new PageContents().logOut();
        }
      });
    }
  }

  getAllFunctionsRoots() {
    var function_roots = org_data.functions;
    var functions_roots_list = [];
    for (var i = 0, len = function_roots.length; i < len; i++) {
      console.log(function_roots[i]);
      if (function_roots[i].includes("assist")) {
      } else if (function_roots[i] == "0") {
        functions_roots_list.push("unclassified");
      } else {
        functions_roots_list.push(function_roots[i]);
      }
    }
    functions_roots_list.sort();
    return functions_roots_list;
  }
  showDropDownList(element_focussed, data) {
    console.log(element_focussed);
    if (element_focussed == "company_name") {
      var companies = data;
      var rows = "";

      for (var i = 0; i < companies.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element_company")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + companies[i].name)
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{company_name}/g, companies[i].name)
            .replace(/{company_id}/g, companies[i].meta.id)
            .replace(/{count}/g, companies[i].count.toLocaleString())
            .replace(/{website}/g, companies[i].meta.website ? companies[i].meta.website : "");
      }
    } else if (element_focussed == "functions") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element_functions")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i])
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{functions}/g, data[i]);
      }
    } else if (element_focussed == "grades") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element_grades")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i])
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{grades}/g, data[i]);
      }
    } else if (
      [
        "company_sizes",
        "company_type",
        "naics",
        "education_majors",
        "education_degrees",
        "genders",
        "locality",
        "region",
        "inferred_salary",
        "function_root",
        "locality_presence",
        "region_presence",
        "country_presence",
        "industry_category",
        "revenue",
      ].includes(element_focussed)
    ) {
      console.log("Got here in element focus of ::,", element_focussed);
      var rows = "";
      if (element_focussed == "function_root" && sessionStorage["current_focus"] == "orgcharts" && sessionStorage["query"] != sessionStorage["blank_session_storage_obj"]) {
        data = this.getAllFunctionsRoots();
        // data = getAllFunctionsFromFunctionAnalytics()
      }
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element_generic")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i])
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{data_item}/g, data[i]);
      }
    } else if (element_focussed == "country") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i].name)
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{company_name}/g, data[i].name)
            .replace(/{count}/g, data[i].count.toLocaleString())
            .replace(/{website}/g, "");
      }
    } else if (element_focussed == "locations") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i].name)
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{company_name}/g, data[i].name)
            .replace(/{count}/g, data[i].count.toLocaleString())
            .replace(/{website}/g, "");
      }
    } else if (element_focussed == "school") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i].name)
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{company_name}/g, data[i].name)
            .replace(/{count}/g, data[i].count.toLocaleString())
            .replace(/{website}/g, "");
      }
    } else if (element_focussed == "reverse_company") {
      var companies = data;
      var rows = "";
      for (var i = 0; i < companies.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element_company")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + companies[i].name)
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{company_name}/g, companies[i].name)
            .replace(/{company_id}/g, companies[i].meta.id)
            .replace(/{count}/g, companies[i].count.toLocaleString())
            .replace(/{website}/g, companies[i].meta.website ? companies[i].meta.website : "");
      }
    } else if (element_focussed != "company_name") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i].name)
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{company_name}/g, data[i].name)
            .replace(/{count}/g, data[i].count.toLocaleString())
            .replace(/{website}/g, "");
      }
    }
    // document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("right_search_results_companies_element").innerHTML
    try {
      document.getElementById("filters_autocomplete_dropdown_list_" + element_focussed).innerHTML = rows;
    } catch (error) {
      console.log("Error:", error);
    }
  }
  showDropDownListCustom(element_focussed, data) {
    console.log("================== data ===========");
    console.log(data);
    console.log(element_focussed);
    let allCondition = [
      "company_sizes",
      "company_type",
      "naics",
      "education_majors",
      "education_degrees",
      "genders",
      "locality",
      "region",
      "inferred_salary",
      "function_root",
      "locality_presence",
      "region_presence",
      "country_presence",
      "industry_category",
      "revenue",
    ].includes(element_focussed);
    if (element_focussed == "company_name") {
      var companies = data;
      var rows = "";
      for (var i = 0; i < companies.length; i++) {
        rows += document
          .getElementById("custom_dropdown_row_element")
          .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + companies[i].name)
          .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
          .replace(/{company_name}/g, companies[i].name)
          .replace(/{company_id}/g, companies[i].meta.id)
          .replace(/{count}/g, companies[i].count.toLocaleString())
          .replace(/{element_focussed}/g, "company_name")
          .replace(/{data_value}/g, companies[i].name)
          .replace(/{website}/g, companies[i].meta.website ? companies[i].meta.website : "");
      }
    } else if (element_focussed == "functions") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("custom_dropdown_row_element")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i])
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{functions}/g, data[i]);
      }
    } else if (element_focussed == "grades") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("custom_dropdown_row_element")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i])
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{grades}/g, data[i]);
      }
    } else if (allCondition) {
      console.log("Got here in element focus of ::,", element_focussed);
      var rows = "";
      if (element_focussed == "function_root" && sessionStorage["current_focus"] == "orgcharts" && sessionStorage["query"] != sessionStorage["blank_session_storage_obj"]) {
        data = this.getAllFunctionsRoots();
        // data = getAllFunctionsFromFunctionAnalytics()
      }
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element_generic")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i])
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{data_item}/g, data[i]);
      }
    } else if (element_focussed == "country") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i].name)
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{company_name}/g, data[i].name)
            .replace(/{count}/g, data[i].count.toLocaleString())
            .replace(/{website}/g, "");
      }
    } else if (element_focussed == "locations") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows += document
          .getElementById("custom_dropdown_row_element")
          .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i].name)
          .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
          .replace(/{company_name}/g, data[i].name)
          .replace(/{element_focussed}/g, "locations")
          .replace(/{data_value}/g, data[i].name)
          .replace(/{count}/g, data[i].count.toLocaleString())
          .replace(/{website}/g, "");
      }
    } else if (element_focussed == "school") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i].name)
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{company_name}/g, data[i].name)
            .replace(/{count}/g, data[i].count.toLocaleString())
            .replace(/{website}/g, "");
      }
    } else if (element_focussed == "reverse_company") {
      var companies = data;
      var rows = "";
      for (var i = 0; i < companies.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element_company")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + companies[i].name)
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{company_name}/g, companies[i].name)
            .replace(/{company_id}/g, companies[i].meta.id)
            .replace(/{count}/g, companies[i].count.toLocaleString())
            .replace(/{website}/g, companies[i].meta.website ? companies[i].meta.website : "");
      }
    } else if (element_focussed != "company_name") {
      var rows = "";
      for (var i = 0; i < data.length; i++) {
        rows =
          rows +
          document
            .getElementById("left_panel_filters_dropdown_row_element")
            .innerHTML.replace("{filters_autocomplete_row_elem_}", "filters_autocomplete_row_elem_" + data[i].name)
            .replace("{dropdown_class_}", "dropdown_class_" + element_focussed)
            .replace(/{company_name}/g, data[i].name)
            .replace(/{count}/g, data[i].count.toLocaleString())
            .replace(/{website}/g, "");
      }
    }
    // document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("right_search_results_companies_element").innerHTML
    try {
      let showdropdown = "dropdown_list_" + element_focussed;
      console.log(showdropdown);
      document.getElementById(showdropdown).innerHTML = rows;
    } catch (error) {
      console.log("Error:", error);
    }
  }

  getDataLoadAutocompleteDropdownHomePage(input_text) {
    if (input_text == sessionStorage["home_page_input_text_token"]) {
      console.log("GOING TO HIT THE FILTERS ENDPOINT!!");
      var params_obj = updateParamsObj();
      $.ajax({
        url: "/filters",
        type: "POST",
        // data : {input_text : input_text, element_focussed:element_focussed},
        data: {
          input_text: input_text,
          element_focussed: "company_name",
          params: params_obj,
          query: sessionStorage["query"],
        },
        error: function (xhr, status) {
          console.log(xhr);
          console.log(status);
          var error_status = xhr.status;
          if (error_status == 599) {
            new PageContents().tokenExpireAction();
          }
          if (error_status == 429) {
            console.log("Too Many Requests");
            document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
            document.getElementById("right_search_results_people_companies_orgcharts_mobi").innerHTML = document.getElementById("too_many_requests_element").innerHTML;
            new ProcessNodesStates().resetSessionStorageforDropdowns();
          }
          if (error_status == 500) {
            // window.location.href = '/'
            console.log("There has been an error in the autocomplete filters on home page");
          }
          // alert(xhr.status);
        },
      }).done(function (response) {
        console.log("This is the AJAX response ", response);
        if (response?.status && response.status == "ok") {
          let data = response.result;
          new SearchBarLoadersDropdowns().showDropDownHomePageList(data);
        } else {
          console.log("when / filters called got this response::", response);
          new PageContents().logOut();
        }
      });
    }
  }

  homeInputElemOnfocus(user_input) {
    // console.log("Called homeInputElemOnfocus")
    // console.log("home page input input on focus")
    // console.log(user_input)
    console.log(user_input.value);
    // console.log(element_focussed)
    mixpanel.track("Input Bar", {
      source: window.location.href.includes("org-chart") ? sessionStorage["current_focus"] : "home_page",
    });
  }

  updateHomePageSearchKeyword(user_input) {
    // window.location.href.includes('org-chart') ? this.showSearchPageSearchBarLoader() :
    if (window.location.href.includes("people") || window.location.href.includes("companies") || window.location.href.includes("org-chart")) {
      this.showSearchPageSearchBarLoader();
    } else {
      this.showFrontPageSearchBarLoader();
    }
    console.log(user_input.value);
    var input_text = user_input.value;
    sessionStorage["home_page_input_text_token"] = input_text;
    setTimeout("new SearchBarLoadersDropdowns().getDataLoadAutocompleteDropdownHomePage('" + input_text + "');", 500);
  }

  showFrontPageSearchBarLoader() {
    var loader = document.getElementById("front_page_search_bar_loader");
    if (loader) {
      loader.innerHTML = '<div style="width:100%;text-align:right; margin-top: -6.5%;margin-left: -1%;"><img style="width:25px" src="/static/img/new_loading2.gif"></div>';
      loader.style.display = "block";
    }
  }

  hideFrontPageSearchbarLoader() {
    var loader = document.getElementById("front_page_search_bar_loader");
    if (loader) {
      loader.innerHTML =
        '<div id="button_dropdown_search_jd" onclick="new SearchBarLoadersDropdowns().placeDropdownBelowSearchforJDInput()" onblur = "" style="cursor:pointer; text-align:right; margin-top: -6.25%;"><img style="width:25px" src="/static/img/new_upload.png"></div>';
    }
    // document.getElementById('front_page_search_bar_loader').style.display = 'none';
  }

  showSearchPageSearchBarLoader() {
    document.getElementById("search_page_search_bar_loader").innerHTML = '<div style="width:100%;text-align:right; margin-top: -7%;margin-left: -1%;"><img style="width:25px" src="/static/img/new_loading2.gif"/></div>';
  }

  hideSearchPageSearchBarLoader() {
    document.getElementById("search_page_search_bar_loader").innerHTML = "";
  }

  showDropDownHomePageList(data) {
    console.log(data);
    var companies = [];
    for (var i = 0; i < data.length; i++) {
      companies.push(data[i].name);
    }

    var home_page_rows = "";
    for (var i = 0; i < data.length; i++) {
      if (data[i].name.length > 50) {
        var display_name = data[i].name.substring(0, 50) + "...";
      } else {
        var display_name = data[i].name;
      }
      var home_page_rows =
        home_page_rows +
        '<a class="dropdown-item form-select" href="javascript:" onclick="new SearchBarLoadersDropdowns().searchAutoCompleteDropDownHomePageClick(this)" country="all" source = "home_page" company_emp_count =' +
        data[i].count +
        " company_id_label= " +
        data[i].meta.id +
        " website_label=" +
        data[i].meta.website +
        ' company_name_label="' +
        data[i].name +
        '">' +
        display_name +
        " (" +
        data[i].count.toLocaleString() +
        ") " +
        "</a>";
    }

    var search_page_rows = "";
    for (var i = 0; i < data.length; i++) {
      if (data[i].name.length > 50) {
        var display_name = data[i].name.substring(0, 50) + "...";
      } else {
        var display_name = data[i].name;
      }
      var search_page_rows =
        search_page_rows +
        '<a class="dropdown-item form-select" href="javascript:"  onclick="new SearchBarLoadersDropdowns().searchAutoCompleteDropDownHomePageClick(this)" country="all" source = "search_page" company_emp_count =' +
        data[i].count +
        " company_id_label= " +
        data[i].meta.id +
        " website_label=" +
        data[i].meta.website +
        ' company_name_label="' +
        data[i].name +
        '">' +
        display_name +
        " (" +
        data[i].count.toLocaleString() +
        ") " +
        "</a>";
    }

    // document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("right_search_results_companies_element").innerHTML
    var all_elems_home_page =
      '<div id = "home_page_search_dropdown_element" class=" dropdown-menu show" aria-labelledby="dropdownMenuButton" style="font-size: 10pt;max-height: 200px;overflow-y: auto;position: relative;margin-left:2.5%; width: 95%;cursor:pointer;">' +
      home_page_rows +
      "</div>";
    var all_elems_mobi_home_page =
      '<div id = "home_page_search_dropdown_element" class=" dropdown-menu show" aria-labelledby="dropdownMenuButton" style="font-size: 10pt;max-height: 200px;overflow-y: auto;position: relative;;width: 85%;cursor:pointer;">' +
      home_page_rows +
      "</div>";
    var all_elems_search_page =
      '<div id = "search_page_search_dropdown_element" class=" dropdown-menu show" aria-labelledby="dropdownMenuButton" style="display:table;font-size: 10pt;max-height: 200px;overflow-y: auto;position: absolute;top: 12%;left:32%;width: 26%; cursor:pointer;">' +
      search_page_rows +
      "</div>";
    var all_elems_search_page_mobi =
      '<div id = "search_page_search_dropdown_element_mobi" class=" dropdown-menu show" aria-labelledby="dropdownMenuButton" style="display:table;font-size: 10pt;max-height: 200px;overflow-x: auto; overflow-y: auto;position: absolute;top: 7%;left:15%;width: 25%; cursor:pointer;">' +
      search_page_rows +
      "</div>";

    try {
      var homePageDropdown = document.getElementById("home_page_dropdown_elements");
      if (homePageDropdown) {
        homePageDropdown.innerHTML = all_elems_home_page;
        homePageDropdown.style.display = "block";
      }
    } catch (error) {
      console.log("Error:", error);
    }
    try {
      var searchPageDropdown = document.getElementById("search_page_center_dropdown_elements");
      var searchPageDropdownMobi = document.getElementById("search_page_center_dropdown_elements_mobi");
      if (searchPageDropdown) searchPageDropdown.innerHTML = all_elems_search_page;
      if (searchPageDropdownMobi) searchPageDropdownMobi.innerHTML = all_elems_search_page_mobi;
    } catch {}
    try {
      var homePageDropdownMobi = document.getElementById("home_page_dropdown_mobi_elements");
      if (homePageDropdownMobi) homePageDropdownMobi.innerHTML = all_elems_mobi_home_page;
    } catch (error) {
      console.log("Error:", error);
    }
    try {
      var searchPageCenterMobi = document.getElementById("search_page_center_dropdown_mobi_elements");
      if (searchPageCenterMobi) searchPageCenterMobi.innerHTML = all_elems_search_page;
    } catch (error) {
      console.log("Error:", error);
    }

    console.log("Got here to finish loading search dropdwown");
    // hideFrontPageSearchbarLoader()

    if (["org-chart", "people", "companies"].includes(window.location.href.split("/")[3])) {
      console.log("Window location href includes org chart");
      var searchBarLoader = document.getElementById("search_page_search_bar_loader");
      if (searchBarLoader) searchBarLoader.innerHTML = "";
    } else {
      console.log("Window location href does not include org chart");
      var frontPageLoader = document.getElementById("front_page_search_bar_loader");
      if (frontPageLoader) {
        frontPageLoader.innerHTML =
          '<div id="button_dropdown_search_jd" onclick="new SearchBarLoadersDropdowns().placeDropdownBelowSearchforJDInput()" style="cursor:pointer; text-align:right; margin-top: -6.25%;"><img style="width:25px" src="/static/img/new_upload.png"></div>';
      }
      // document.getElementById('front_page_search_bar_loader').style.display = 'none';
    }
    // new SearchBarLoadersDropdowns().addEventListenerHomePageInputElementOnBlur()
  }

  updateSessionStorageWithCompanyCounts(user_input) {
    var company_id_label = user_input.getAttribute("company_id_label");
    var company_emp_count = user_input.getAttribute("company_emp_count");
    var new_emp_count_obj = {};
    new_emp_count_obj["company_id_label"] = company_id_label;
    new_emp_count_obj["company_emp_count"] = company_emp_count;
    var existing_company_emp_counts = JSON.parse(sessionStorage["company_emp_counts"]);
    existing_company_emp_counts.push(new_emp_count_obj);
    sessionStorage["company_emp_counts"] = JSON.stringify(existing_company_emp_counts);
  }

  searchAutoCompleteDropDownHomePageClick(user_input) {
    // panda = user_input
    console.log("Got to this searchAutoCompleteDropDownHomePageClick");
    sessionStorage["data_source"] = "arxena";
    console.log(user_input);
    console.log(user_input.innerHTML);
    console.log(user_input.getAttribute("company_name_label"));
    console.log(user_input.getAttribute("company_id_label"));
    console.log(user_input.getAttribute("website_label"));
    // Method 1
    // updateSessionStorageWithCompanyCounts(user_input)
    // company_name_clicked = user_input.getAttribute('company_name_label')
    // company_id_clicked = user_input.getAttribute('company_id_label')
    // token_obj = {"company_id": company_id_clicked, "company_name":company_name_clicked}
    // updateStorageToken(token_obj, 'home_page_dropdown')

    // changePage('/org-chart')

    new ProcessNodesStates().resetSessionStorageforDropdowns();
    // Method 2

    sessionStorage["load_type"] = "query";
    this.updateSessionStorageWithCompanyCounts(user_input);
    var company_name_clicked = user_input.getAttribute("company_name_label");
    var company_id_clicked = user_input.getAttribute("company_id_label");
    var website_clicked = user_input.getAttribute("website_label");
    var source = user_input.getAttribute("source");
    var token_obj = {
      company_id: company_id_clicked,
      company_name: company_name_clicked,
      website: website_clicked,
    };
    updateStorageToken(token_obj, "home_page_dropdown");

    // fetchQueryShowResults()
    // if( source == 'home_page'){
    // window.location.href = '/org-chart'  + '/' + company_id_clicked
    // }
    // else{
    new PageContents().changePage("/org-chart");

    // after showing tokens; clear up the damn thing.

    mixpanel.track("Company DropDown Clicked", {
      source: window.location.href.includes("org-chart") ? sessionStorage["current_focus"] : "home_page",
    });
  }
}


export { LeftPanelDropdownFilters, DragDropdJDFile, SearchBarLoadersDropdowns };
if (typeof window !== 'undefined') {
  window.LeftPanelDropdownFilters = LeftPanelDropdownFilters;
  window.DragDropdJDFile = DragDropdJDFile;
  window.SearchBarLoadersDropdowns = SearchBarLoadersDropdowns;
}
